import { Table, Tag, Radio, Space, Input, Button, Pagination, message, Modal, TreeSelect, Spin } from 'antd';
import { useState } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
// import { userList, updateRole } from "@/apis/user";
import { useEffect } from 'react';
import { tags_list, update_tag } from "@/apis/tag"

// let typeList = [];
const presets = [
	'#f50',
	'volcano',
	'orange',
	'gold',
	'#87d068',
	'lime',
	'green',
	'cyan',
	'#108ee9',
	'#2db7f5',
	'blue',
	'geekblue',
	'purple',
	'magenta',
	'red',
];
const TagsManage = () => {
	const [params, setParams] = useState({
		pageSize: 10,
		currentPage: 1,
	})
	const [keywords, setKeywords] = useState("");
	// const [isResourceOpen, setIsResourceOpen] = useState(false);
	const [isCssOpen, setIsCssOpen] = useState(false);
	// const [selectType, setSelectType] = useState([]);
	const [tagColor, setTagTagColor] = useState("");
	const [tagUuid, setTagUuid] = useState("");
	const [loading, setLoading] = useState(false);
	const [tag, setTag] = useState("");
	const [data, setData] = useState([]);

	const getList = () => {
		setLoading(true);
		tags_list({
			...params,
			keywords
		}).then(res => {
			setData(res.data.records);
			setTotal(res.data.total);
			setLoading(false)
		}).catch(err => {
			setLoading(false)
		})
	}

	// useEffect(() => {
	// fetch('/share.json')
	// 	.then(response => response.json())
	// 	.then(jsonData => {
	// 		typeList = jsonData.typeList
	// 	})
	// 	.catch(error => console.error('Error fetching data:', error));
	// }, []);

	// const openModal = (arr, id) => {
	// 	typeList.forEach(item => {
	// 		item.children.forEach(child => {
	// 			if (arr.includes(child.value)) {
	// 				child.disabled = true
	// 			}else{
	// 				child.disabled = false
	// 			}
	// 		})
	// 	})
	// 	setIsResourceOpen(true);
	// 	setSourceId(id);
	// 	setSelectType(arr || [])
	// }

	const [total, setTotal] = useState(0)
	const columns = [
		{
			title: "标签",
			key: 'tag',
			dataIndex: 'tag',
			render: (text, record) => {
				return <Tag color={record.style}>
					{text}
				</Tag>
			},
		},

		{
			title: "所属资源",
			key: 'resourceNames',
			dataIndex: 'resourceNames',
			// render: (text, record) => {
			// 	return <div className={styles.sourceBox}>
			// 		{text.map(item => item + "，")}
			// 	</div>
			// },
		},
		{
			title: "被用次数",
			key: 'resourceCount',
			dataIndex: 'resourceCount',
		},
		{
			title: "修改样式",
			key: 'opreation',
			dataIndex: "style",
			render: (text, record) => {
				return <Button color="danger" onClick={() => opencssModal(text, record.tagUuid, record.tag)} variant="text" size="small">选择</Button>
			},
		},
		// {
		// 	title: "分配资源",
		// 	key: 'opreation',
		// 	dataIndex: 'source',
		// 	render: (text, record) => {
		// 		return <Button
		// 			color="primary"
		// 			variant="text"
		// 			size="small"
		// 			onClick={() => openModal(text, record.id)}>
		// 			分配
		// 		</Button>
		// 	},
		// },
	];

	const getTagList = () => {
		setParams({
			...params,
			currentPage: 1
		})
	}


	const handleKeyDown = (e) => {
		if (e.keyCode === 13) {
			getTagList()
		}
	}

	// const handleOk = () => {
	// 	setData(data.map(item => item.id === sourceId ? { ...item, source: selectType } : item));
	// 	setIsResourceOpen(false);
	// }
	// const handleCancel = () => {
	// 	setIsResourceOpen(false);
	// }

	const handleCssOk = () => {
		setIsCssOpen(false);
		update_tag({ tagUuid: tagUuid, style: tagColor, tag: tag }).then(res => {
			message.success("修改成功")
			setData(data.map(item => item.tagUuid === tagUuid ? { ...item, style: tagColor } : item));
		}).catch(err => {
			message.error("修改失败")
		})
	}

	const opencssModal = (style, id, tag) => {
		setTagTagColor(style);
		setIsCssOpen(true);
		setTagUuid(id)
		setTag(tag)
	}

	useEffect(() => {
		getList()
	}, [params])

	return <Spin spinning={loading}>
		<div className={classNames('container', styles.userBox)}>
			<h3>标签管理</h3>
			<Space.Compact className={styles.paramsBox}>
				<Input
					allowClear
					placeholder="标签名称"
					onKeyDown={handleKeyDown}
					onClear={getTagList}
					onChange={(e) => {
						setKeywords(e.target.value);
					}} />
				<Button type="primary" onClick={getTagList}>搜索</Button>
			</Space.Compact>
			<Table rowKey={record => record.uuid} pagination={false} columns={columns} dataSource={data} />
			<Pagination
				align="end"
				style={{ marginTop: "20px" }}
				current={params.currentPage}
				pageSize={params.pageSize}
				total={total}
				showSizeChanger={false}
				showQuickJumper
				onChange={(page, pageSize) => {
					setParams({
						...params,
						currentPage: page,
						pageSize: pageSize,
					});
				}}
			/>
			{/*
							<Modal
				title="分配资源"
				open={isResourceOpen}
				onOk={handleOk}
				onCancel={handleCancel}
				width={700}
			>
				<TreeSelect
					showSearch
					style={{
						width: '100%',
					}}
					value={selectType}
					multiple
					fieldNames={{ label: 'label', value: 'value', children: 'children' }}
					placeholder="请选择"
					treeDefaultExpandAll={true}
					treeCheckable
					onChange={(e) => {
						setSelectType(e)
					}}
					treeData={typeList}
				/>
			</Modal>
				 */}
			<Modal
				title="修改样式"
				open={isCssOpen}
				onOk={handleCssOk}
				onCancel={() => {
					setIsCssOpen(false)
				}}
				width={565}
			>
				<Radio.Group value={tagColor}>
					{presets.map(color => (
						<Radio onChange={(e) => {
							setTagTagColor(e.target.value);
						}} style={{ width: "120px", marginTop: 15 }} key={color} value={color}>
							<Tag color={color} variant="outlined">
								{color}
							</Tag>
						</Radio>
					))}
				</Radio.Group>
			</Modal>
		</div>
	</Spin>
}
export default TagsManage;